import type { ApolloClient } from '@apollo/client';
import { GetMeasuringPointsDocument, type GetMeasuringPointsQuery } from '@/graphql/types';
import { getPreviewProjects } from '../../../previewContextModels';

export const PROJECT_MEASURING_POINTS_BINDING_ID = 'project.measuring_points.measuring_points';

export async function resolveProjectArgOptions(args: {
    client: ApolloClient<object>;
}): Promise<Array<[string, string]>> {
    const { data } = await args.client.query<GetMeasuringPointsQuery>({
        query: GetMeasuringPointsDocument,
        fetchPolicy: 'cache-first',
    });
    return getPreviewProjects(data).map((project): [string, string] => [project.id, project.name]);
}
